import "./AestheticFill.module.css";
import Header from "@/reusable_sections/Header";
import EstetikDolguTanitimi from "./sections/EstetikDolguTanitimi";
import ProtectionTechniques from "./sections/ProtectionTechniques";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function AestheticFillPage() {
  return <div>
      <Header />
      <EstetikDolguTanitimi />
      <ProtectionTechniques />
      <Projects />
      <Footer />
    </div>;
}